import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Preloader from '../../../components/common/Preloader';
import { viewEnter, viewLeave } from '../actions';
import BetList from '../BetList';
import NoBets from '../NoBets';
import { getListVisible, hasOpenBets, isViewLoading } from '../selectors';
import SingleBet from '../SingleBet';

const mapStateToProps = state => ({
  hasBets: hasOpenBets(state),
  showList: getListVisible(state),
  loading: isViewLoading(state)
});

const mapDispatchToProps = {
  viewEnter,
  viewLeave
};

export class Page extends React.Component {
  componentWillMount() {
    this.props.viewEnter();
  }

  componentWillUnmount() {
    this.props.viewLeave();
  }

  render() {
    const { hasBets, showList, loading } = this.props;
    let content = showList ? <BetList /> : <SingleBet />;
    content = hasBets ? content : <NoBets />;
    const contentToShow = loading ? (
      <div className="open-bets__preloader">
        <Preloader text="Loading bets..." />
      </div>
    )
      : content;

    return (
      <div className="open-bets">
        {contentToShow}
      </div>
    );
  }
}

Page.propTypes = {
  hasBets: PropTypes.bool,
  showList: PropTypes.bool,
  viewEnter: PropTypes.func.isRequired,
  viewLeave: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
